import React, { useEffect, useRef, useState } from "react";
import "../../../incidents/cases/addCaseList.scss";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../../library/custom/button/Button";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import { TableLoader } from "../../../../library/common/Loader";
import { GRID_DEFAULT_PAGE_SIZE, ROW_PER_PAGE_SIZE } from "../../../../constant/constant";
import TableRowAction from "../../../../library/custom/gridTable/TableRowAction";
import NORow from "../../../../library/custom/noRow/noRow";
import DialogBox from "../../../../library/common/DialogBox";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { getPreviousRoute } from "../../../../utils/routeTracker";
import {
  ADMIN_VIEW_DIVISION,
  ADMIN_EDIT_DIVISION,
} from "../../../../constant/routeContant";
import { useDebounce } from "../../../../utils/useDebounceSearch";

const DivisionList = ({
  divisionsListData,
  getDivisionsListData,
  addDivision,
  isLoading,
  handleDeleteOnClick,
  handleEditOnClick,
  handleViewOnClick,
  onRowClick,
  divisionsListDatas,
  deleteDivisions,
}) => {
  // Lazy state initialization: check if we should preserve state
  const [search, setSearch] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADMIN_VIEW_DIVISION) ||
        previousRoute.startsWith(ADMIN_EDIT_DIVISION)) &&
      sessionStorage.getItem("divisionListPreserveState") === "true";

    if (shouldPreserve) {
      const savedSearch = sessionStorage.getItem("divisionListSearch");
      return savedSearch || "";
    }
    return "";
  });
  const debouncedSearch = useDebounce(search, 500);
  const isFirstRender = useRef(true);

  const [page, setPage] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADMIN_VIEW_DIVISION) ||
        previousRoute.startsWith(ADMIN_EDIT_DIVISION)) &&
      sessionStorage.getItem("divisionListPreserveState") === "true";

    if (shouldPreserve) {
      const savedPage = sessionStorage.getItem("divisionListPage");
      return savedPage ? parseInt(savedPage) : 0;
    }
    return 0;
  });

  const [pageSize, setPageSize] = useState(() => {
    const previousRoute = getPreviousRoute();
    const shouldPreserve =
      previousRoute &&
      (previousRoute.startsWith(ADMIN_VIEW_DIVISION) ||
        previousRoute.startsWith(ADMIN_EDIT_DIVISION)) &&
      sessionStorage.getItem("divisionListPreserveState") === "true";

    if (shouldPreserve) {
      const savedPageSize = sessionStorage.getItem("divisionListPageSize");
      return savedPageSize ? parseInt(savedPageSize) : GRID_DEFAULT_PAGE_SIZE;
    }
    return GRID_DEFAULT_PAGE_SIZE;
  });

  // Clear sessionStorage flags after mount
  React.useEffect(() => {
    sessionStorage.removeItem("divisionListPreserveState");
    sessionStorage.removeItem("divisionListSearch");
    sessionStorage.removeItem("divisionListPage");
    sessionStorage.removeItem("divisionListPageSize");
  }, []);

  const [isTableLoading, setisTableLoading] = useState(false);

  // Initial data load on mount
  useEffect(() => {
    const data = {
      page: page + 1,
      pageSize: pageSize,
      search: search || "",
      isSendMail: false,
    };
    getDivisionsListData(data);
  }, []);

  // Handle delete success - reset state and reload data
  useEffect(() => {
    if (deleteDivisions?.status === "SUCCESS") {
      setSearch("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      const data = {
        page: 1,
        pageSize: GRID_DEFAULT_PAGE_SIZE,
        search: "",
        isSendMail: false,
      };
      getDivisionsListData(data);
    }
  }, [deleteDivisions]);

  const handleautoSearch = (event) => {
    const searchText = event?.target?.value || "";
    setSearch(searchText);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getDivisionsListData({
      page: newPage + 1,
      pageSize: pageSize,
      search: search ? search : "",
      isSendMail: false,
    });
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    getDivisionsListData({
      page: 1,
      pageSize: newPazeSize,
      search: search ? search : "",
      isSendMail: false,
    });
  };

  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteDivision = (divisionId) => {
    setOpenModal(true);
    setSelectedRow(divisionId);
  };
  const deletehandle = () => {
    setOpenModal(false);
    handleDeleteOnClick(selectedRow);
  };

  const columns = [
    { field: "divisionId", headerName: "Division ID", flex: 1 },
    { field: "divisionName", headerName: "Division Name", flex: 1 },
    { field: "stateName", headerName: "State", flex: 1 },
    {
      field: "",
      width: 170,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <TableRowAction
            rows={rows}
            edit={checkPrivileges([12, 49, 50])}
            view={checkPrivileges([12, 49, 50, 51])}
            viewLabel="View Division"
            editLabel="Edit Division"
            viewOnClick={(row) => handleViewOnClick(row?.divisionId)}
            editOnClick={(row) => handleEditOnClick(row?.divisionId)}
            deleteOnClick={(row) => deleteDivision(row?.divisionId)}
          />
        );
      },
    },
  ];

  const sendEmail = () => {
    const data = {
      page: 1,
      pageSize: pageSize,
      search: search ? search : "",
      isSendMail: true,
    };
    getDivisionsListData(data);
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    const data = {
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch ? debouncedSearch : "",
      isSendMail: false,
    };

    getDivisionsListData(data);
  }, [debouncedSearch]);

  return (
    <section className="grid_main_sec">
      {openModal && (
        <DialogBox
          open={openModal}
          rows={[]}
          header={"Confirm Deletion"}
          deletehandle={deletehandle}
          handleCloseModal={() => setOpenModal(false)}
          content={"Are you sure you want to delete this Division?"}
          view
        />
      )}
      <div className="grid_main_header two_grid">
        <div className="grid_heading_style">Divisions</div>
        <div>
          {checkPrivileges([12, 49, 50]) && (
            <Buttons
              id="btnAddDivision"
              label={"Add Division"}
              varientAddIconBlue={true}
              onClick={() => addDivision()}
            />
          )}
        </div>
      </div>
      <div className="grid_main_body">
        <div className="div-filter-container">
          <div className="filter_of_caselist">
            <div className="searchcaseid">
              <label htmlFor="search">
                <span>
                  <SearchIcon />
                </span>
                <div>
                  <input
                    id="search"
                    placeholder="Search"
                    type="text"
                    value={search}
                    className=""
                    onChange={handleautoSearch}
                    autoComplete="off"
                  />
                </div>
              </label>
            </div>
          </div>
          <div className="div-download-email-right" onClick={sendEmail}>
            <span>
              <img
                src={downloadIcon}
                className="DownLoadLogo"
                alt="DownLoad Logo"
              />
            </span>
            Download Data
          </div>
        </div>
        {isTableLoading ? (
          ""
        ) : (
          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              <GridTable
                getRowId={(r) => r.divisionId}
                columns={columns}
                rows={divisionsListData?.getDivisionLists ?? []}
                rowCount={divisionsListData?.itemsCount ?? 0}
                loading={isLoading}
                components={{
                  LoadingOverlay: TableLoader,
                  NoRowsOverlay: NORow,
                }}
                onClick={(rows) => onRowClick(rows)}
                rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                onPageSizeChange={handlePageSizeChange}
                page={page}
                pagination
                pageSize={pageSize}
                onPageChange={handlePagignation}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default DivisionList;
